var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8333V3.83333C3 3.3029 3.21071 2.79419 3.58579 2.41912C3.96086 2.04405 4.46957 1.83333 5 1.83333H12.3333C12.5101 1.83333 12.6797 1.90357 12.8047 2.0286C12.9298 2.15362 13 2.32319 13 2.5V10.8333H4.91667M3 10.83V12.4167",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 14.1667H4.66667C4.22464 14.1667 3.80072 13.9911 3.48816 13.6785C3.17559 13.366 3 12.942 3 12.5C3 12.058 3.17559 11.634 3.48816 11.3215C3.80072 11.0089 4.22464 10.8333 4.66667 10.8333H13V13.5C13 13.6768 12.9298 13.8464 12.8047 13.9714C12.6797 14.0964 12.5101 14.1667 12.3333 14.1667Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 8V4.02667H10.0668V8H9.4375Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39258 8L6.78991 4.02667H7.56858L8.96591 8H8.29391L7.98991 7.10933H6.37391L6.06458 8H5.39258ZM6.55524 6.54933H7.79791L7.09391 4.46933H7.26991L6.55524 6.54933Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyIconDark);
export default __webpack_public_path__ + "static/media/policyIconDark.3163c5831123b0fb7187bdd22fc42ad4.svg";
export { ForwardRef as ReactComponent };